import type { ChipPreferenceOption } from '@/components/UI/ChipPreferenceRow';

export type NotificationPreferenceChipValue = 'all' | 'mentions' | 'none';

export const NOTIFICATION_PREFERENCE_OPTIONS: readonly ChipPreferenceOption<NotificationPreferenceChipValue>[] =
  [
    { icon: 'notifications-outline', label: 'All', value: 'all' },
    { icon: 'at-outline', label: 'Mentions', value: 'mentions' },
    { icon: 'notifications-off-outline', label: 'Off', value: 'none' },
  ];
